import { Table, Flex, Collapse, Typography, Space, List, Col, Row } from 'antd'
import React from 'react'

const { Text, Title } = Typography

function ANSILaserClassResults(props) {
    const condition = props.condition || 1
    // console.log("ANSI AEL", props)
    // const { laserOperation, CE3isPersqm, condition1, condition2, condition3, timeBase, conditionIsEmpty } = props.laserClass

    /**
     * 
     * @param {*} laserClass  'c1', 'c2', 'c3r' or 'c3b'
     * @param {*} unitToReturn 'joules' or 'watts'
     * @returns Returns the AEL given the laser class and unit to return.
     */

    /**
     * 
     * @param {*} laserClass 
     * @returns returns the excess given the laser class.
     */


    /**
     * 
     * @param {*} aelType 'single', 'pulseTrain' or 'Average'
     * @param {*} laserClass 
     */

    const data = (() => {
        let column = []
        let dataSource = []
        if (props.laserOperation.includes('repetitivelyPulsed')) {
            column = [
                {
                    key: 1,
                    title: 'Laser Class',
                    dataIndex: 'name',
                    align: 'center',
                    width: '20%'
                },
                {
                    key: 2,
                    title: 'Accessible Emission Limit',
                    align: 'center',
                    children: ([
                        {
                            key: 1,
                            title: <Text strong>AEL <sub>single </sub></Text>,
                            dataIndex: 'AEL',
                            align: 'center',

                        },
                        {
                            key: 2,
                            title: <Text strong>AEL <sub>s.p. Train </sub></Text>,
                            dataIndex: 'AELPulseTrain',
                            align: 'center',

                        },
                        {
                            key: 3,
                            title: <Text strong>AEL <sub>s.p.T</sub></Text>,
                            dataIndex: 'AELSPT',
                            align: 'center',

                        },

                    ])
                },
                {
                    key: 3,
                    title: <Text strong>AEL <sub>T</sub></Text>,
                    dataIndex: 'AELT',
                    align: 'center',
                },
                {
                    key: 4,
                    title: 'Emission Hazard Value',
                    dataIndex: 'excess',
                    align: 'center',
                    width: '15%'
                },
                {
                    key: 5,
                    title: 'Pass/Fail',
                    dataIndex: 'pf',
                    align: 'center',
                    width: '15%'
                }

            ]
            dataSource = [
                {
                    key: 1,
                    name: 'AEL for Class 1',
                    AEL: <Text style={mostRestrictiveCheckANSI('single', 'class1', props)} strong type={AEcompareANSI('single', 'class1', props)}>{props.results[`condition${condition}`].class1?.AEL?.single?.aelStandard?.pretty}</Text>,
                    AELPulseTrain: <Text style={mostRestrictiveCheckANSI('pulseTrain', 'class1', props)} strong type={AEcompareANSI('pulseTrain', 'class1', props)}>{props.results[`condition${condition}`].class1?.AEL?.pulseTrain?.pretty}</Text>,
                    AELSPT: <Text style={mostRestrictiveCheckANSI('SPT', 'class1', props)} strong type={AEcompareANSI('SPT', 'class1', props)}>{props.results[`condition${condition}`].class1?.AEL?.SPT?.pretty}</Text>,
                    AELT: props.results[`condition${condition}`].class1?.AEL?.T?.aelStandard?.pretty,
                    excess: (
                        <Text strong type={passFailANSI('class1', props).style}>
                            {props.results[`condition${condition}`].class1?.EHV?.pretty}
                        </Text>

                    ),
                    pf: <Text strong type={passFailANSI('class1', props).style}>{props.results[`condition${condition}`].class1?.P_F}</Text>
                },
                {
                    key: 2,
                    name: `AEL for Class 2`,
                    AEL: <Text style={mostRestrictiveCheckANSI('single', 'class2', props)} strong type={AEcompareANSI('single', 'class2', props)}>{props.results[`condition${condition}`].class2?.AEL?.single?.aelStandard?.pretty}</Text>,
                    AELPulseTrain: <Text style={mostRestrictiveCheckANSI('pulseTrain', 'class2', props)} strong type={AEcompareANSI('pulseTrain', 'class2', props)}>{props.results[`condition${condition}`].class2?.AEL?.pulseTrain?.pretty}</Text>,
                    AELSPT: <Text style={mostRestrictiveCheckANSI('SPT', 'class2', props)} strong type={AEcompareANSI('SPT', 'class2', props)}>{props.results[`condition${condition}`].class2?.AEL?.SPT?.pretty}</Text>,
                    AELT: props.results[`condition${condition}`].class2?.AEL?.T?.aelStandard?.pretty,
                    excess: (
                        <Text strong type={passFailANSI('class2', props).style}>
                            {props.results[`condition${condition}`].class2?.EHV?.pretty}
                        </Text>

                    ),
                    pf: <Text strong type={passFailANSI('class2', props).style}>{props.results[`condition${condition}`].class2?.P_F}</Text>
                },
                {
                    key: 3,
                    name: `AEL for Class 3R`,
                    AEL: <Text style={mostRestrictiveCheckANSI('single', 'class3r', props)} strong type={AEcompareANSI('single', 'class3r', props)}>{props.results[`condition${condition}`].class3r?.AEL?.single?.aelStandard?.pretty}</Text>,
                    AELPulseTrain: <Text style={mostRestrictiveCheckANSI('pulseTrain', 'class3r', props)} strong type={AEcompareANSI('pulseTrain', 'class3r', props)}>{props.results[`condition${condition}`].class3r?.AEL?.pulseTrain?.pretty}</Text>,
                    AELSPT: <Text style={mostRestrictiveCheckANSI('SPT', 'class3r', props)} strong type={AEcompareANSI('SPT', 'class3r', props)}>{props.results[`condition${condition}`].class3r?.AEL?.SPT?.pretty}</Text>,
                    AELT: props.results[`condition${condition}`].class3r?.AEL?.T?.aelStandard?.pretty,
                    excess: (
                        <Text strong type={passFailANSI('class3r', props).style}>
                            {props.results[`condition${condition}`].class3r?.EHV?.pretty}
                        </Text>
                    ),
                    pf: <Text strong type={passFailANSI('class3r', props).style}>{props.results[`condition${condition}`].class3r?.P_F}</Text>
                },
                {
                    key: 4,
                    name: 'AEL for Class 3B',
                    AEL: <Text style={mostRestrictiveCheckANSI('single', 'class3b', props)} strong type={AEcompareANSI('single', 'class3b', props)}>{props.results[`condition${condition}`].class3b?.AEL?.single?.aelStandard?.pretty}</Text>,
                    AELPulseTrain: <Text style={mostRestrictiveCheckANSI('pulseTrain', 'class3b', props)} strong type={AEcompareANSI('pulseTrain', 'class3b', props)}>{props.results[`condition${condition}`].class3b?.AEL?.pulseTrain?.pretty}</Text>,
                    AELSPT: <Text style={mostRestrictiveCheckANSI('SPT', 'class3b', props)} strong type={AEcompareANSI('SPT', 'class3b', props)}>{props.results[`condition${condition}`].class3b?.AEL?.SPT?.pretty}</Text>,
                    AELT: props.results[`condition${condition}`].class3b?.AEL?.T?.aelStandard?.pretty,
                    excess: (
                        <Text strong type={passFailANSI('class3b', props).style}>
                            {props.results[`condition${condition}`].class3b?.EHV?.pretty}
                        </Text>
                    ),
                    pf: <Text strong type={passFailANSI('class3b', props).style}>{props.results[`condition${condition}`].class3b?.P_F}</Text>
                },
                {
                    key: 4,
                    name: <Text strong>Accessible Emission</Text>,
                    AEL: (
                        <Text strong>
                            {`${props.results[`condition${condition}`]?.details?.collectedEmission?.joulesPretty} | ${props.results[`condition${condition}`]?.details?.collectedEmission?.wattsPretty}`}
                            {/* {`${collectedEmission('joules',undefined, props)} | ${collectedEmission('watts',undefined, props)}`} */}
                        </Text>
                    ),
                    // AELPulseTrain: props.results[`condition${condition}`]?.details?.collectedEmission?.wattsPretty,
                }
            ]
        }
        else {
            column = [
                {
                    key: 1,
                    title: 'Laser Class',
                    dataIndex: 'name',
                    align: "center",
                    width: '33%'
                },
                {
                    key: 2,
                    title: 'Accessible Emission Limit',
                    dataIndex: 'AEL',
                    align: "center"
                },
                {
                    key: 3,
                    title: 'Emission Hazard Value',
                    dataIndex: 'excess',
                    align: 'center'
                },
                {
                    key: 4,
                    title: 'Pass/Fail',
                    dataIndex: 'pf',
                    align: 'center'
                },

            ]
            const myCollectedEmission = (() => {

                return {
                    key: 5,
                    name: <Text strong>Accessible Emission</Text>,
                    AEL: (
                        <Text strong>
                            {`${props.results[`condition${condition}`]?.details?.collectedEmission?.joulesPretty} | ${props.results[`condition${condition}`]?.details?.collectedEmission?.wattsPretty}`}
                            {/* {`${collectedEmission('joules',undefined, props)} | ${collectedEmission('watts',undefined, props)}`} */}
                        </Text>
                    ),
                    wattsPerSqm: (
                        <Text strong>
                            {props.results[`condition${condition}`]?.details?.wattsPretty}
                            {/* {collectedEmission('watts',undefined, props)} */}
                        </Text>
                    ),

                }

            })()
            dataSource = [
                {
                    key: 1,
                    name: 'AEL for Class 1',
                    AEL: <Text strong type={AEcompareANSI('single', 'class1', props)}>{props.results[`condition${condition}`].class1?.AEL?.single.aelStandard?.pretty}</Text>,
                    excess: (
                        <Text strong type={passFailANSI('class1', props).style}>
                            {props.results[`condition${condition}`].class1?.EHV?.pretty}
                        </Text>


                    ),
                    pf: <Text strong type={passFailANSI('class1', props).style}>{props.results[`condition${condition}`].class1?.P_F}</Text>

                },
                {
                    key: 2,
                    name: `AEL for Class 2`,
                    AEL: <Text strong type={AEcompareANSI('single', 'class2', props)}>{props.results[`condition${condition}`].class2?.AEL?.single.aelStandard?.pretty}</Text>,
                    excess: (
                        <Text strong type={passFailANSI('class2', props).style}>
                            {props.results[`condition${condition}`].class2?.EHV?.pretty}
                        </Text>

                    ),
                    pf: <Text strong type={passFailANSI('class2', props).style}>{props.results[`condition${condition}`].class2?.P_F}</Text>
                },
                {
                    key: 3,
                    name: `AEL for Class 3R`,
                    AEL: <Text strong type={AEcompareANSI('single', 'class3r', props)}>{props.results[`condition${condition}`].class3r?.AEL?.single.aelStandard?.pretty}</Text>,
                    excess: (
                        <Text strong type={passFailANSI('class3r', props).style}>
                            {props.results[`condition${condition}`].class3r?.EHV?.pretty}
                        </Text>

                    ),
                    pf: <Text strong type={passFailANSI('class3r', props).style}>{props.results[`condition${condition}`].class3r?.P_F}</Text>

                },
                {
                    key: 4,
                    name: 'AEL for Class 3B',
                    AEL: <Text strong type={AEcompareANSI('single', 'class3b', props)}>{props.results[`condition${condition}`].class3b?.AEL?.single.aelStandard?.pretty}</Text>,
                    excess: (
                        <Text strong type={passFailANSI('class3b', props).style}>
                            {props.results[`condition${condition}`].class3b?.EHV?.pretty}
                        </Text>

                    ),
                    pf: <Text strong type={passFailANSI('class3b', props).style}>{ props.results[`condition${condition}`].class3b?.P_F }</Text>
                },
                myCollectedEmission
            ]

        }

        return (
            {
                column: column,
                dataSource: dataSource,
            }
        )

    })()

    return (
        <>
            <Flex justify='center' style={{ width: '100%' }}>
                <Table
                    title={() => (
                        <Flex style={{ width: '100%' }} justify="center">
                            <Text style={{ fontSize: '15px' }} strong>Condition {props?.condition}</Text>
                        </Flex>
                    )}
                    style={{ width: '100%', margin: '12px', overflowX: "auto" }}
                    size="small"
                    scroll={{ x: 600 }}
                    pagination={false}
                    bordered
                    columns={data.column}
                    dataSource={data.dataSource}
                    footer={() => (
                        <Collapse
                            size="small"
                            items={[
                                {
                                    key: 1,
                                    label: (
                                        <Flex justify='center'>
                                            <Flex>
                                                <Text strong type="warning">
                                                    More info
                                                </Text>
                                            </Flex>
                                        </Flex>
                                    ),
                                    children: (
                                        <>
                                            <Row justify="center">
                                                <Col lg={12} sm={24} justify='center' style={{ width: '100%', padding: '12px' }} >
                                                    <Space direction='vertical'>
                                                        <Flex justify='center'><Title level={4}>Legend</Title></Flex>
                                                        <List bordered>
                                                            <List.Item>The AE values displayed in <Typography.Text strong type={'danger'}>red font</Typography.Text> indicate that the collected emission has exceeded the specified limit.</List.Item>
                                                            <List.Item>The AE values displayed in <Typography.Text strong type={'success'}>green font</Typography.Text> indicate that the collected emission is within the specified limit.</List.Item>
                                                            {/* {laserOperation === 'RP' || laserOperation === "FO_RP" ? <List.Item>The AE values highlighted in orange indicate that specified value is the <Text strong style={{ background: `#F8BD14` }}>Most Restrictive AEL.</Text></List.Item> : null} */}
                                                        </List>

                                                    </Space>
                                                </Col>
                                                <Col lg={12} sm={24}>
                                                    <Table
                                                        style={{ width: '100%' }}
                                                        size="small"
                                                        pagination={false}
                                                        bordered
                                                        columns={[
                                                            {
                                                                key: 1,
                                                                title: `Condition ${props.condition} Misc Results`,
                                                                dataIndex: 'name',
                                                                align: 'right',
                                                                width: '80%'
                                                            },
                                                            {
                                                                key: 2,
                                                                title: 'Value',
                                                                dataIndex: 'value',
                                                                align: 'center'
                                                            }
                                                        ]}
                                                        dataSource={[
                                                            {
                                                                key: 1,
                                                                name: 'Aperture Stop',
                                                                value: props.results[`condition${condition}`]?.details?.measurementAperture?.apertureDiameter + " mm"
                                                            },
                                                            {
                                                                key: 2,
                                                                name: 'Aperture Distance',
                                                                value: props.results[`condition${condition}`]?.details?.measurementAperture?.measurementDistance + " cm"
                                                            },
                                                            // {
                                                            //     key: 3,
                                                            //     name: 'Angular Subtense',
                                                            //     value: props.laserClass[`condition${condition}`]?.angularSubtense !== null ? props.laserClass[`condition${condition}`]?.angularSubtense : '-'
                                                            // },
                                                            // {
                                                            //     key: 4,
                                                            //     name: 'Value for C₆',
                                                            //     value: props.laserClass[`condition${condition}`]?.C6
                                                            // },
                                                            {
                                                                key: 5,
                                                                name: 'Acceptance Angle',
                                                                value: `-`
                                                            }
                                                        ]}
                                                    />
                                                </Col>
                                            </Row>
                                            <Flex justify='center' style={{ width: '100%' }}>
                                                <Text type='secondary'>Note: The correction factors used are displayed on the respective Class tabs</Text>
                                            </Flex>
                                        </>
                                    )
                                }
                            ]}
                        />
                    )}
                />
            </Flex>

        </>
    )
}

const mostRestrictiveCheckANSI = (aelType, laserClass, props) => {
    const condition = props.condition || 1
    const { results, laserOperation } = props
    const x = {
        c1: 'class1',
        c2: 'class2',
        c3r: 'class3r',
        c3b: 'class3b'
    }
    const orange = '#F8BD14'
    // console.log("mostrest", results[`condition${condition}`][laserClass]?.AEL)
    if (laserOperation === "repetitivelyPulsed_ansi" || laserOperation === "FO_RP") {
        const mostRestrictive = results[`condition${condition}`][laserClass]?.mostRestrictive?.num
        if (aelType === 'single') {
            if (mostRestrictive === results[`condition${condition}`][laserClass]?.AEL.single.aelStandard.num) {
                return { background: '#F8BD14' }
            } else {
                return { background: null }
            }

        } else {
            if (results[`condition${condition}`][laserClass]?.AEL[aelType].num !== 0) {
                if (mostRestrictive === results[`condition${condition}`][laserClass]?.AEL[aelType].num && (results[`condition${condition}`][laserClass]?.AEL.single.aelStandard.num !== results[`condition${condition}`][laserClass]?.AEL[aelType].num)) {
                    return { background: orange }
                } else {
                    return { background: null }
                }
            }
        }

    }
}

function AEcompareANSI(aelType, laserClass, props) {
    const condition = props.condition || 1
    const { condition1, condition2, condition3, results } = props

    // if (condition === 1) {
    // if (!condition1.collectedEmissionJoules.joulesPretty.includes('NaN')) {
    if (aelType === 'single') {
        if (results[`condition${condition}`][laserClass]?.AEL.single.aelStandard?.unit?.includes("J")) {
            if (results[`condition${condition}`].details.collectedEmission.joules <= results[`condition${condition}`][laserClass]?.AEL[aelType].aelStandard.num) {
                return 'success'
            } else {
                return 'danger'
            }
        }
        else {
            if (results[`condition${condition}`].details.collectedEmission.watts <= results[`condition${condition}`][laserClass]?.AEL[aelType].aelStandard.num) {
                return 'success'
            } else {
                return 'danger'
            }
        }
    }
    else {
        if (results[`condition${condition}`][laserClass]?.AEL.single.aelStandard.unit?.includes("J")) {
            if (results[`condition${condition}`].details.collectedEmission.joules <= results[`condition${condition}`][laserClass]?.AEL[aelType].num) {
                return 'success'
            } else {
                return 'danger'
            }
        }
        else {
            if (results[`condition${condition}`].details.collectedEmission.watts <= results[`condition${condition}`][laserClass]?.AEL[aelType].num) {
                return 'success'
            } else {
                return 'danger'
            }
        }
    }
}

// function collectedEmission(unitToReturn, returnStandard = false, props) {
//     const condition = props.condition || 1
//     const { condition1, condition2, condition3, CE3isPersqm} = props.laserClass
//     if (condition === 1) {
//         if (condition1.collectedEmissionWatts.wattsPretty.includes('NaN')) {
//             return '-'
//         } else {
//             if (unitToReturn === 'joules') {
//                 return condition1.collectedEmissionWatts.joulesPretty
//             } else {
//                 return condition1.collectedEmissionJoules.wattsPretty
//             }
//         }

//     }
//     else if (condition === 2) {
//         if (condition2.collectedEmissionWatts.wattsPretty.includes('NaN')) {
//             return '-'
//         } else {
//             if (unitToReturn === 'joules') {
//                 return condition2.collectedEmissionWatts.joulesPretty
//             } else {
//                 return condition2.collectedEmissionJoules.wattsPretty
//             }
//         }
//     }
//     else {
//         // condiition  3
//         if (condition3.collectedEmissionWatts.wattsPretty.includes('NaN')) {
//             return '-'
//         } else {
//             if (unitToReturn === 'joules') {
//                 if (CE3isPersqm) {
//                     if (returnStandard) {
//                         return condition3.collectedEmissionJoules.joulesPretty
//                     } else {
//                         return condition3.collectedEmissionPerSqm.joulesPretty + '/m²'
//                     }
//                 } else {
//                     return condition3.collectedEmissionJoules.joulesPretty
//                 }
//             } else {
//                 if (CE3isPersqm) {
//                     if (returnStandard) {
//                         return condition3.collectedEmissionWatts.wattsPretty
//                     } else {
//                         return condition3.collectedEmissionPerSqm.wattsPretty + '/m²'
//                     }
//                 } else {
//                     return condition3.collectedEmissionWatts.wattsPretty
//                 }
//             }
//         }
//     }
// }

// function excess(laserClass, props) {
//     const condition = props.condition || 1
//     const { condition1, condition2, condition3} = props.laserClass
//     if (condition === 1) {
//         // condition 1
//         if (typeof condition1.AEL_standard.Excess[`${laserClass}excess`].raw === 'number') {
//             return condition1.AEL_standard.Excess[`${laserClass}excess`].pretty
//         } else {
//             return '-'
//         }
//     }
//     else if ( condition === 2) {
//         // condition 2
//         if (typeof condition2.AEL_standard.Excess[`${laserClass}excess`].raw === 'number') {
//             return condition2.AEL_standard.Excess[`${laserClass}excess`].pretty
//         } else {
//             return '-'
//         }
//     } else {
//         // condition 3
//         if (typeof condition3.AEL_standard.Excess[`${laserClass}excess`].raw === 'number') {
//             return condition3.AEL_standard.Excess[`${laserClass}excess`].pretty || '-'
//         } else {
//             return condition3.AEL_standard.Excess[`${laserClass}excess`].raw || '-'
//         }
//     }
// }

function passFailANSI(laserClass, props) {
    const condition = props.condition || 1
    const { condition1, condition2, condition3, results } = props
    // if (condition === 1) {
    if (results[`condition${condition}`][laserClass]?.EHV.num == undefined) {
        return { style: null, value: '-' }
    }
    else if (results[`condition${condition}`][laserClass]?.EHV.num > 1) {
        return { style: 'danger', value: 'Fail' }
    }
    else if (results[`condition${condition}`][laserClass]?.EHV.num <= 1) {
        return { style: 'success', value: 'Pass' }
    }
}

export { ANSILaserClassResults, AEcompareANSI, passFailANSI, mostRestrictiveCheckANSI }